import React, { useContext } from "react";
import Edit from "../../icons/Edit.svg";
import Delete from "../../icons/Delete.svg";
import View from "../../icons/View.svg";
import { useSelector } from "react-redux";
import { AuthContext } from "../../contexts/AuthContext";
// import download from "../../icons/download.svg";
import download from "../../icons/PDFDownload.svg";
import viewSheet from "../../icons/ViewComparisonSheet.svg";
import save_default from "../../icons/Save_Default.svg";
import popup from "../../icons/CustomerLinking.svg";

export default (props) => {
  const { accessibleMenus } = useContext(AuthContext);
  const menuName = useSelector((state) => state.menu.menuName);
  const menuAccess = accessibleMenus?.filter(item => item.SessionName === menuName) || [];
  let temp = { ViewAction: true, EditAction: true, DownloadAction: true, DeleteAction: true, SaveAction: true };
  if (props.hasOwnProperty("actionName") && Object.keys(props.actionName).length > 0) {
    temp = props.actionName;
  } else {
    const currentMenu = menuAccess[0] || {};
    temp = {
      ViewAction: currentMenu.Display || true,
      EditAction: currentMenu.Modify || true,
      DownloadAction: true,
      SaveAction: true,
      DeleteAction: currentMenu.Delete || true,
    };
  }
  return (
    <div>
      {props.handleViewComparisonSheet ?
        <img
          className="action-icon"
          src={viewSheet}
          alt="comparison-sheet"
          title="View Comparison Sheet"
          onClick={() => props.handleViewComparisonSheet(props.selectedData)}/> :
        <></>
      }
      {temp.DownloadAction && props.handleDownloadEvent ?
        <img
          className="action-icon"
          src={download}
          alt="pdf-download"
          title="PDF Download"
          onClick={() => props.handleDownloadEvent(props.selectedData)} /> :
        <></>
      }
      {temp.ViewAction && props.handleViewEvent ?
        <img
          className="action-icon"
          src={View}
          alt="view"
          title="View"
          onClick={() => props.handleViewEvent(props.selectedData)} /> : <></>
      }
      {temp.EditAction && props.handleEditEvent ?
        <img
          className="action-icon"
          src={Edit}
          alt="edit"
          title="Edit"
          onClick={() => props.handleEditEvent(props.selectedData)}
        /> : <></>
      }
      {props.handleCustomerLinkEvent ?
        <img
          className="action-icon"
          src={popup}
          alt="Link/De-link Customers"
          title="Link/De-link Customers"
          onClick={() => props.handleCustomerLinkEvent(props.selectedData)}
        />
        : (
          <></>
        )}
      {props.handleCopyEvent ?
        <img
          className="action-icon"
          src={save_default}
          alt="copy"
          title="Copy"
          onClick={() => props.handleCopyEvent(props.selectedData)}
        /> : <></>
      }
      {temp.DeleteAction && props.handleDeleteEvent ?
        <img
          className="action-icon"
          src={Delete}
          alt="delete"
          title="Delete"
          onClick={() => props.handleDeleteEvent(props.selectedData)}
        />
        : (
          <></>
        )}
      {/* {temp.SaveAction ?
        <img
          className="action-icon"
          src={save_default}
          alt="save_default"
          onClick={() => props.handleSaveEvent(props.selectedData)}
        />
        : <></>
      } */}
      {props.handlePlaceBidEvent ?
        <button
          className="btn btn-sm btn-success"
          onClick={() => props.handlePlaceBidEvent(props.selectedData)}
          style={{ fontSize: '12px', padding: '4px 8px' }}
        >
          Place Bid
        </button>
        : <></>
      }
      {props.handleUpdateSalesOrder ?
        <button
          className="btn btn-sm btn-success"
          onClick={() => props.handleUpdateSalesOrder(props.selectedData)}
          style={{ fontSize: '12px', padding: '4px 8px' }}
        >
          Update Sales Order
        </button>
        : <></>
      }
      {props.handleShowHistory ?
        <button
          className="btn btn-sm btn-success"
          onClick={() => props.handleShowHistory(props.selectedData)}
          style={{ fontSize: '12px', padding: '4px 8px', marginLeft: '5px' }}
        >
          History
        </button>
        : <></>
      }
    </div>
  );
};
